module.exports = __webpack_public_path__ + "static/media/poster.a3c92cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/poster.png
// module id = ./src/static/img/poster.png
// module chunks = 0